import {publicOfficeInfoShape} from '_app/shapes';
import './office-contact-info.less';

const parseCountryInfo = (city, state, zip) => (!city && !state && !zip)
	? null
	: (city ? city : '') +
	(city && (state || zip) ? ', ' : '') +
	(state ? state : '') +
	(state && zip ? ' ' : '') +
	(zip ? zip : '');

const OfficeContactInfo = ({office: {firmName, phone, email, website, facebook, twitter, linkedin, locations}}) => (
	<div className="row office-contact-info">
		<div className="col-md-1" />
		<div className="col-md-2">
			{firmName && <strong className="office-contact-info-text-row" title={firmName}>{firmName}</strong>}
			{phone && (
				<p><a className="office-contact-info-text-row" href={`tel:${phone}`} title={phone}>
					{phone}
				</a></p>
			)}
			{email && (
				<p><a className="office-contact-info-text-row" href={`mailto:${email}`} title={email}>
					{email}
				</a></p>
			)}
			{website && (
				<p><a className="office-contact-info-text-row" href={website} target="_blank" title={website}>
					{website}
				</a></p>
			)}
			{facebook && <a href={facebook} target="_blank" className="office-contact-info-icon fa fa-facebook" />}
			{twitter && <a href={twitter} target="_blank" className="office-contact-info-icon fa fa-x-twitter" />}
			{linkedin && <a href={linkedin} target="_blank" className="office-contact-info-icon fa fa-linkedin" />}
		</div>
		{locations.map(location => {
			const parsedCountryInfo = parseCountryInfo(location.city, location.state, location.zip);

			return (
				<div key={`location-${location.officeLocationNumber}`} className="col-md-2">
					{location.city && (
						<strong className="office-contact-info-text-row" title={`${location.city} Office`}>{location.city} Office</strong>
					)}
					{location.address && <p className="office-contact-info-text-row" title={location.address}>{location.address}</p>}
					{location.address2 && <p className="office-contact-info-text-row" title={location.address2}>{location.address2}</p>}
					{parsedCountryInfo && <p className="office-contact-info-text-row" title={parsedCountryInfo}>{parsedCountryInfo}</p>}
					{location.phone && (
						<p><a className="office-contact-info-text-row" href={`tel:${location.phone}`} title={location.phone}>
							{location.phone}
						</a></p>
					)}
				</div>
			);
		})}
		<div className="col-md-1" />
	</div>
);

OfficeContactInfo.propTypes = {
	office: publicOfficeInfoShape
};

export default OfficeContactInfo;